<template>
  <v-row class="mx-2">
    <v-col :style="{ 'padding-left': padding }">
      <v-col
        cols="12"
        md="8"
        sm="6"
        xs="4"
        style="max-width: 100%"
        class="d-flex justify-space-between mx-auto"
      >
        <v-btn color="info" text class="my-auto pl-0" @click="goToSchedule">
          <v-img
            src="@/assets/icons/anterior.png"
            style="cursor: pointer"
            alt="anterior"
            max-width="30"
            max-height="30"
            dark
          />Permiso
        </v-btn>
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard">
        <CardsView
          :items="paginatedItems"
          :openDialog="openDialog"
          :title="title"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-else>
        <TableWithSearch
          :items="paginatedItems"
          :headers="allHeaders"
          :title="title"
          :openDialog="openDialog"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <v-row class="ma-0 pa-0" justify="center">
        <v-col cols="12" md="8" lg="6">
          <v-pagination
            v-if="groups?.length > 0"
            class="paginado ma-0 pa-0"
            v-model="currentPage"
            :length="totalPages"
            prev-icon="mdi-chevron-left"
            next-icon="mdi-chevron-right"
            hide-delimiter-background
            :items-per-page="limit"
            @input="changePage"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-dialog
      v-model="openGroup"
      max-width="600px"
      persistent
      @keydown.esc="cancel"
    >
      <v-card max-width="600px">
        <v-card-title
          style="display: flex; justify-content: center"
          class="mb-5"
        >
          {{ mode }}
        </v-card-title>
        <v-alert
          dense
          v-if="error"
          color="red"
          elevation="5"
          outlined
          text
          type="error"
          align="center"
          class="mr-1 ml-1"
        >
          {{ alertValidate }}</v-alert
        >
        <v-form
          @submit.prevent="validation"
          class="ml-5 mr-5"
          ref="form"
          v-model="valid"
        >
          <date-with-check :showCheck="true" class="mb-4" />
          <v-select
            required
            :rules="rules"
            label="Segmento"
            dense
            outlined
            v-model="data.segment"
            :items="segments"
            item-value="id"
            item-text="name"
            @change="changeSegment"
          />
          <v-text-field
            :label="$tc('changeSchedule.sequenceNumber')"
            dense
            outlined
            v-model="data.sequenceNumber"
            disabled
          />

          <v-text-field
            v-model="data.initialDay"
            :label="$tc('changeSchedule.initialDay')"
            outlined
            dense
            type="number"
            :max="initialDay"
            :min="1"
            :disabled="changeSeg"
            :rules="rulesDays"
          />

          <v-autocomplete
            :rules="rules"
            :label="$tc('schedules.groups')"
            outlined
            v-model="data.groups"
            :items="getAllGroups"
            multiple
            item-value="groupId"
            item-text="name"
            v-if="typeForm == 'add'"
          >
            <template v-slot:selection="{ item, index }">
              <v-chip v-if="index < 3">
                <span>{{ item.name }}</span>
              </v-chip>
              <span v-if="index === 3" class="grey--text text-caption">
                (+ {{ data.groups.length - 3 }} )
              </span>
            </template>
          </v-autocomplete>
          <div class="d-flex justify-space-between pb-4">
            <v-btn class="bt-exit" @click="cancel">{{
              $tc("editRegistrations.cancel")
            }}</v-btn>
            <v-btn type="submit" class="bt-acept">
              {{ $tc("editRegistrations.acept") }}</v-btn
            >
          </div>
        </v-form>
      </v-card>
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import schedules from "@/store/permisosDeAcceso/accessPermissions";
import groups from "@/store/permisosDeAcceso/groups";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import date from "@/store/common/date";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    DateWithCheck,
    CardsView,
    TableWithSearch,
    ButtonsCardList,
    Form,
    DeleteDialog,
    Snackbar,
  },

  data() {
    return {
      showCard: true,
      title: this.$tc("schedules.groups"),
      titleTable: "PermisosDeAcceso_Grupos",
      color: "",
      titleDelete: "este grupo?",
      headers: [
        {
          text: "Grupos",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Desde",
          value: "formattedDesde",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Hasta",
          value: "formattedHasta",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Segmento",
          value: "segmentName",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      maxWidth: "550px",
      valid: true,
      typeForm: "",
      itemToDelete: null,
      itemId: null,
      alert: false,
      textAlert: "",
      data: {
        segment: null,
        initialDay: 1,
        sequenceNumber: null,
        groups: [],
      },
      error: false,
      alertValidate: "",
      initialDay: null,
      changeSeg: true,
      itemEdit: null,
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
      rulesDays: [
        (v) =>
          (v !== null && v !== undefined && v !== "" && this.validateDays(v)) ||
          `El número está fuera del rango. El rango válido es de 1 a ${this.initialDay}`,
      ],
      currentPage: 1,
      limit: 20,
    };
  },

  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    groups() {
      return groups.state.groups;
    },
    getAllGroups() {
      const allGroups = this.$store.state.changeGroup.group.item;
      const selectedGroupIds = groups.state.groups;
      return allGroups?.filter(
        (groups) => !selectedGroupIds.some((e) => e.id === groups.groupId)
      );
    },
    padding() {
      return schedules.state.paddingNav;
    },
    openGroup: {
      get() {
        return groups.state.openGroup;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    mode: {
      get() {
        return groups.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    openDelete: {
      get() {
        return groups.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },

    segments() {
      return schedules.state.permissionSegments;
    },
    validInitialDay() {
      return this.initialDay !== null;
    },
    totalPages() {
      return Math.ceil(this.groups.length / this.limit);
    },
    paginatedItems() {
      const start = (this.currentPage - 1) * this.limit;
      const end = start + this.limit;
      return this.groups.slice(start, end);
    },
  },
  mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },

  methods: {
    changePage(page) {
      this.currentPage = page;
    },
    async refreshItems() {
      await groups.dispatch("getGroups");
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    saveForm() {
      let payload;
      switch (this.typeForm) {
        case "add":
          this.addGroup();
          break;
        case "edit":
          this.editGroup();
          break;
        default:
          break;
      }
    },
    validation() {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.saveForm();
      } else {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 3000);

        this.alertValidate = this.$tc("editRegistrations.required");
      }
    },
    initialDays(selectedData) {
      let inicialDay = schedules.state.permissionSegments?.find((option) => {
        return option.id == selectedData;
      });
      return inicialDay.days;
    },
    changeSegment(id) {
      const searchNumSequense = schedules.state.permissionSegments.find(
        (item) => {
          return item.id === id;
        }
      );
      this.changeSeg = false;
      this.data.sequenceNumber = searchNumSequense.numberSequence;
      this.initialDay = this.initialDays(this.data.segment);
    },
    validateDays(value) {
      if (!this.validInitialDay) {
        return true;
      }
      return value >= 1 && value <= this.initialDay;
    },
    goToSchedule() {
      schedules.dispatch("handleShowWindow", "schedule");
    },
    cancel() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      this.$refs.form.resetValidation();
      (this.data = {
        segment: null,
        initialDay: 1,
        sequenceNumber: null,
        groups: [],
      }),
        (this.error = false);
      groups.commit("setOpenGroup", false);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    async openDialog(type, item) {
      try {
        this.alert = false;
        this.typeForm = type;

        schedules.commit("setPermissionId", schedules.state.permissionId);
        groups.commit("setPermissionId", groups.state.permissionId);

        switch (this.typeForm) {
          case "add":
            schedules.dispatch("getSegmentsPermissionId").then(() => {
              if (schedules.state.permissionSegments.length === 0) {
                this.alert = true;
                this.textAlert = this.$tc("schedules.noSegmentAlert");
                this.color = "#FF8D58";
              } else {
                this.$store.dispatch("changeGroup/getGroups");
                groups.commit("setMode", this.$tc("schedules.addGroup"));
                groups.commit("setOpenGroup", true);
              }
            });
            break;

          case "delete":
            groups.commit("setOpenDelete", true);
            this.itemToDelete = {
              id: item.id,
              permissionId: schedules.state.permissionId,
              from: item.from,
            };
            break;

          case "edit":
            groups.commit("setMode", this.$tc("schedules.editGroup"));

            await Promise.all([
              this.$store.dispatch("changeGroup/getGroups"),
              schedules.dispatch("getSegmentsPermissionId"),
            ]);

            const busco = schedules.state.permissionSegments?.find(
              (segment) => segment.id === item.segmentId
            );

            this.data = {
              segment: item.segmentId,
              initialDay: item.segementDesploy,
              sequenceNumber: busco?.numberSequence || null,
            };

            this.itemEdit = {
              id: item.id,
              name: item.name,
              fromOld: item.from.slice(0, 10),
            };

            groups.commit("setOpenGroup", true);
            date.commit("setDateFrom", item.from.slice(0, 10));
            date.commit("setDateTo", item.to ? item.to.slice(0, 10) : null);

            const hasInstans =
              Array.isArray(item.instans) && item.instans.length > 0;
            date.commit(
              "setCheckTo",
              hasInstans ? !item.instans[0].fecHasta : true
            );

            break;

          default:
            break;
        }
      } catch (error) {
        console.error("Error en openDialog:", error);
      }
    },

    cardView(value) {
      this.showCard = value;
    },
    selectedGroupNames() {
      const names = this.$store.state.changeGroup.group.item
        .filter((item) => this.data.groups.includes(item.groupId))
        .map((item) => item.name);
      return names;
    },
    addGroup() {
      const payload = {
        permisoId: schedules.state.permissionId,
        fecDesde: date.state.dateFrom,
        fecHasta: date.state.dateTo,
        segmId: this.data.segment,
        segmDespl:
          typeof this.data.initialDay === "number"
            ? this.data.initialDay
            : Number(this.data.initialDay),
        grps: this.data.groups,
      };

      groups.commit("setNew", payload);
      groups
        .dispatch("new")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("schedules.addGroupSuccess");
          this.color = "#82A1D0";
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
      this.cancel();
    },
    editGroup() {
      const payload = {
        id: this.itemEdit.id,
        permisoId: schedules.state.permissionId,
        fecDesde: date.state.dateFrom,
        fecDesdeOld: this.itemEdit.fromOld,
        fecHasta: date.state.dateTo,
        segmId: this.data.segment,
        segmDespl:
          typeof this.data.initialDay === "number"
            ? this.data.initialDay
            : Number(this.data.initialDay),
      };
      if (date.state.checkTo) {
        payload.fecHasta = null;
      }
      groups.commit("setEdit", payload);
      groups
        .dispatch("edit")
        .then(() => {
          this.refreshItems();
          this.alert = true;
          this.textAlert = this.$tc("schedules.editGroupSuccess");
          this.color = "#82A1D0";
          groups.dispatch("getGroups");
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });

      this.cancel();
    },
    deleteItem() {
      groups.commit("setDeleteItem", this.itemToDelete);
      groups
        .dispatch("delete")
        .then(() => {
          this.alert = true;
          this.textAlert = this.$tc("schedules.deleteGroupSuccess");
          this.color = "#82A1D0";
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
      this.cancelDelete();
    },
    cancelDelete() {
      groups.commit("setOpenDelete", false);
    },
  },
};
</script>
<style scoped>
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
